/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Justnow1Inputs */

const he_common_justnow1 = /** @type {(inputs: Common_Justnow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עכשיו`)
};

const en_common_justnow1 = /** @type {(inputs: Common_Justnow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just now`)
};

/**
* | output |
* | --- |
* | "Just now" |
*
* @param {Common_Justnow1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_justnow1 = /** @type {((inputs?: Common_Justnow1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Justnow1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_justnow1(inputs)
	return en_common_justnow1(inputs)
});
export { common_justnow1 as "common_justNow" }